import { TResApi, TResApiErr, TResDataListApi } from '@src/configs/interface.config'
import { checkAuth } from '@src/libs/localStorage'
import { TComment, TPatchGameComment, TPatchManyComment, TQueryCommentByContest } from '@src/modules/game-comment'
import { useMutation, useQuery } from 'react-query'
import { notification } from 'antd'
import { NError, NSuccess } from '@src/configs/const.config'
import {
  deleteManyComment,
  getListComment,
  patchGameCommentById,
  patchManyGameCommentById,
  removeContestCommentById,
} from '@queries/apis'
import { LIST_COMMENT } from '@queries/keys'

import { queryClient } from '..'

export const useQueryListComment = (contestId: string, params: TQueryCommentByContest) => {
  const accessToken = checkAuth()
  return useQuery<TResDataListApi<TComment[]>>(
    [LIST_COMMENT, contestId, JSON.stringify(params)],
    () => getListComment(contestId, params),
    {
      enabled: !!accessToken,
    },
  )
}

/**
 * @method useMutationRemoveCommentById
 * @returns
 */
export const useMutationRemoveCommentById = () =>
  useMutation((id: string) => removeContestCommentById(id), {
    onSuccess: (res: TResApi) => {
      queryClient.refetchQueries([LIST_COMMENT]).then()
      notification.success({ message: NSuccess, description: res?.message })
    },
    onError: (error: TResApiErr) => {
      // [TODO] ...
      notification.error({ message: NError, description: error?.message })
    },
  })

/**
 * @method useMutationPatchGameCommentById
 * @returns
 */
export const useMutationPatchGameCommentById = () =>
  useMutation(({ id, data }: { id: string; data: TPatchGameComment }) => patchGameCommentById(id, data), {
    onSuccess(res: TResApi<TComment>) {
      queryClient.refetchQueries([LIST_COMMENT]).then()
      notification.success({ message: NSuccess, description: res?.message })
    },
    onError: (error: TResApiErr) => {
      // [TODO] ...
      notification.error({ message: NError, description: error?.message })
    },
  })

/**
 * @method useMutationDeleteManyGameComment
 * @returns
 */
export const useMutationDeleteManyGameComment = () =>
  useMutation(({ ids }: { ids: string[] }) => deleteManyComment(ids), {
    onSuccess(res: TResApi<TComment>) {
      queryClient.refetchQueries([LIST_COMMENT]).then()
      notification.success({ message: NSuccess, description: res?.message })
    },
    onError: (error: TResApiErr) => {
      // [TODO] ...
      notification.error({ message: NError, description: error?.message })
    },
  })

/**
 * @method useMutationPatchGameCommentById
 * @returns
 */
export const useMutationPatchManyGameComment = () =>
  useMutation(({ data }: { data: TPatchManyComment }) => patchManyGameCommentById(data), {
    onSuccess(res: TResApi<TComment>) {
      queryClient.refetchQueries([LIST_COMMENT]).then()
      notification.success({ message: NSuccess, description: res?.message })
    },
    onError: (error: TResApiErr) => {
      // [TODO] ...
      notification.error({ message: NError, description: error?.message })
    },
  })
